<template>
  <div class="drawback-tab pt-2" :class="{ 'px-5': !breakpointXs, 'px-2': breakpointXs }">
    <ValidationObserver @keydown.tab="focusNext" v-slot="{ passes }">
      <v-row>
        <v-col cols="12" :xs="12" :sm="8" :md="8" :lg="8">
          <AutoComplete
            rules="required"
            v-model="dbkScheduleDropdownValue"
            :items="drawbackRates"
            required
            showIcons
            :showOnlyErrorIcons="true"
            item-text="text"
            :return-object="true"
            :disabled="!isDbkItem"
            :loading="isDrawbackFormLoading || savingExportJob"
            label="DBK Sr. No."
          />
        </v-col>
        <v-col cols="12" :xs="12" :sm="4" :md="4" :lg="4">
          <TextField
            :disabled="!isDbkItem"
            :loading="isDrawbackFormLoading || savingExportJob"
            v-model="dbkRate"
            suffix="%"
            label="DBK Rate"
          />
        </v-col>
      </v-row>
      <div
        class="drawback-tab__upper-form boxed-form"
        :class="{ 'pt-2 px-6': !breakpointXs, 'pa-0 px-2': breakpointXs }"
      >
        <v-row>
          <v-col
            cols="2"
            class="d-flex align-center justify-center font-weight-medium"
            :class="{ 'fs-15': !breakpointXs, 'fs-10': breakpointXs }"
          >
            Quantity
          </v-col>
          <v-col cols="4" :xs="6" :sm="6" :md="4" :lg="4">
            <TextField
              :disabled="!isDbkItem"
              v-model="dbkQuantity"
              :loading="isDrawbackFormLoading || savingExportJob"
            />
          </v-col>
          <v-col cols="1" class="d-flex align-center justify-center hide-sm-and-down fs-15 font-weight-medium">|</v-col>
          <v-col cols="4" :xs="6" :sm="6" :md="4" :lg="4">
            <TextField :loading="isDrawbackFormLoading || savingExportJob" disabled v-model="quantityUnit" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="2"
            class="d-flex align-center justify-center font-weight-medium"
            :class="{ 'fs-15': !breakpointXs, 'fs-10': breakpointXs }"
          >
            DBK Amount
          </v-col>
          <v-col cols="4">
            <TextField :disabled="!isDbkItem" :loading="isDrawbackFormLoading || savingExportJob" v-model="dbkAmount" />
          </v-col>
          <v-col cols="1" class="d-flex align-center justify-center fs-15 hide-sm-and-down font-weight-medium">@</v-col>
          <v-col cols="4">
            <TextField
              :disabled="!isDbkItem"
              :loading="isDrawbackFormLoading || savingExportJob"
              :value="dbkRate !== undefined && dbkRate !== null ? dbkRate + '% of FOB value' : ''"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            :xs="12"
            :sm="2"
            :md="2"
            :lg="2"
            class="d-flex align-center justify-center font-weight-medium"
            :class="{ 'fs-15': !breakpointXs, 'fs-10': breakpointXs }"
            >Declarations</v-col
          >
          <v-col cols="4" :xs="6" :sm="5" :md="5" :lg="4">
            <AutoComplete
              rules="required"
              showIcons
              required
              :showOnlyErrorIcons="true"
              :items="declarations"
              :disabled="!isDbkItem"
              item-text="statementText"
              v-model="declaration1"
              :return-object="true"
              :loading="isDrawbackFormLoading || savingExportJob"
            />
          </v-col>
          <v-col cols="1" class="d-flex align-center justify-center fs-15 font-weight-medium hide-sm-and-down">|</v-col>
          <v-col cols="4" :xs="6" :sm="5" :md="5" :lg="4">
            <AutoComplete
              rules="required"
              :items="declarations"
              :disabled="!isDbkItem"
              item-text="statementText"
              showIcons
              required
              :showOnlyErrorIcons="true"
              v-model="declaration2"
              :return-object="true"
              :loading="isDrawbackFormLoading || savingExportJob"
            />
          </v-col>
        </v-row>
      </div>
      <v-row class="px-2 py-2">
        <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
          <div class="d-sm-flex justify-start" :class="{ 'text-center': breakpointXs }">
            <v-btn
              width="140"
              :loading="isDrawbackFormLoading || savingExportJob"
              color="info"
              large
              class="white--text"
              @click="$emit('change-tab', 1)"
            >
              <v-icon class="font-weight-bold fs-15 mr-2">fa fa-arrow-circle-left</v-icon>
              <span class="font-weight-bold fs-15">Previous</span>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" :xs="12" :sm="6" :md="6" :lg="6">
          <div class="d-sm-flex justify-end" :class="{ 'text-center': breakpointXs }">
            <v-btn
              width="140"
              :loading="isDrawbackFormLoading || savingExportJob"
              color="button-primary"
              large
              class="white--text"
              @click="passes(saveDrawbackTab)"
            >
              <span class="font-weight-bold fs-15">Save</span>
            </v-btn>
            <div class="ml-2 mr-2 my-1"></div>
            <v-btn
              width="140"
              :loading="isDrawbackFormLoading || savingExportJob"
              color="info"
              large
              class="white--text"
              @click="$emit('change-tab', 2)"
            >
              <span class="font-weight-bold fs-15">Next</span>
              <v-icon class="font-weight-bold fs-15 ml-2">fa fa-arrow-circle-right</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </ValidationObserver>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import TextField from "@/components/TextField";
// import SelectField from "@/components/SelectField";
import AutoComplete from "@/components/AutoComplete";
import * as MT from "@/modules/DashboardModule/modules/ImportExportModule/modules/ExportModule/store/mutationTypes";
import handleExportJobMixin from "@/modules/DashboardModule/modules/ImportExportModule/mixins/handleExportJobMixin";
import commonMethodsMixin from "@/modules/commonMethodsMixin";

export default {
  name: "DrawbackTab",
  components: {
    ValidationObserver,
    TextField,
    // SelectField,
    AutoComplete
  },
  data() {
    return {
      dbkUnder: "",
      isDbkItem: true,
      isDrawbackFormLoading: false,
      dialog: false,
      srNo: "",
      description: "",
      exciseDBKRate: "",
      customeDBKRate: "",
      unit: "",
      quantity: "",
      isModalFormLoading: false,
      declaration1: null,
      declaration2: null
    };
  },
  mounted() {
    this.retrieveDrawbackDetails();
    this.retrieveDeclarations();
  },
  beforeDestroy() {
    this.makeFieldsNull();
  },
  props: {
    itemSrNo: {
      type: Number,
      default: 1
    },
    invoiceSrNo: {
      type: Number,
      default: 1
    }
  },
  mixins: [commonMethodsMixin, handleExportJobMixin],
  methods: {
    retrieveDeclarations() {
      // retrieving declaration 1
      const declaration1 = this.$store.getters.exportJob.statements.find(
        statement =>
          statement.invoiceSrNo === this.invoiceSrNo && statement.itemSrNo === this.itemSrNo && statement.srNo === 1
      );
      this.declaration1 = declaration1 !== undefined && declaration1.statementText !== undefined ? declaration1 : null;

      // retrieving declaration 2
      const declaration2 = this.$store.getters.exportJob.statements.find(
        statement =>
          statement.invoiceSrNo === this.invoiceSrNo && statement.itemSrNo === this.itemSrNo && statement.srNo === 2
      );
      this.declaration2 = declaration2 !== undefined && declaration2.statementText !== undefined ? declaration2 : null;
      return;
    },
    retrieveDrawbackDetails() {
      const dbk = this.$store.getters.exportJob.dbks.find(
        dbk => dbk.invoiceSrNo === this.invoiceSrNo && dbk.itemSrNo === this.itemSrNo
      );
      if (dbk !== undefined) {
        this.$store.commit(MT.SET_DRAWBACK_FROM_EXPORT_JOB, dbk);
      }
      return;
    },
    saveDrawbackTab() {
      this.saveDrawbackInvoiceItemDetails();
      const drawback = { ...this.$store.getters.drawback };
      this.$store.commit(MT.SET_DRAWBACK_IN_EXPORT_JOB, drawback);
      this.saveDeclarations();
      this.saveExportJob();
      return;
    },
    saveDrawbackInvoiceItemDetails() {
      this.$store.commit(MT.SET_DRAWBACK_INVOICE_SR_NO, { value: this.invoiceSrNo });
      this.$store.commit(MT.SET_DRAWBACK_ITEM_SR_NO, { value: this.itemSrNo });
      return;
    },
    saveDeclarations() {
      if (this.declaration1 !== null) {
        const statementDeclaration1 = { ...this.$store.getters.statement };
        statementDeclaration1.invoiceSrNo = this.invoiceSrNo;
        statementDeclaration1.itemSrNo = this.itemSrNo;
        statementDeclaration1.srNo = 1;
        statementDeclaration1.statementType = "DEC";
        if (this.declaration1.textIdentifier === undefined) {
          statementDeclaration1.statementCode = this.declaration1.statementCode;
        } else {
          statementDeclaration1.statementCode = this.declaration1.textIdentifier;
        }
        statementDeclaration1.statementText = this.declaration1.statementText;
        this.$store.commit(MT.SET_STATEMENT_IN_EXPORT_JOB, statementDeclaration1);
      }
      if (this.declaration2 !== null) {
        const statementDeclaration2 = { ...this.$store.getters.statement };
        statementDeclaration2.invoiceSrNo = this.invoiceSrNo;
        statementDeclaration2.itemSrNo = this.itemSrNo;
        statementDeclaration2.srNo = 2;
        statementDeclaration2.statementType = "DEC";
        if (this.declaration1.textIdentifier === undefined) {
          statementDeclaration2.statementCode = this.declaration2.statementCode;
        } else {
          statementDeclaration2.statementCode = this.declaration2.textIdentifier;
        }
        statementDeclaration2.statementText = this.declaration2.statementText;
        this.$store.commit(MT.SET_STATEMENT_IN_EXPORT_JOB, statementDeclaration2);
      }
      return;
    },
    reCalculateDbkAmount() {
      const invoice = this.$store.state.ExportModuleStore.invoice;
      const item = this.$store.state.ExportModuleStore.item;

      const exchangeRate =
        invoice.exchangeRate !== null && invoice.exchangeRate !== undefined ? parseFloat(invoice.exchangeRate) : 1;

      const itemValue =
        item !== undefined && item !== null && item.itemValue !== undefined ? parseFloat(item.itemValue) : 0;

      const freight = invoice.freightAmount !== null ? parseFloat(invoice.freightAmount) : 0;
      const insurance = invoice.insuranceAmount !== null ? parseFloat(invoice.insuranceAmount) : 0;
      const fob = itemValue - freight - insurance;
      const dbkRate = parseFloat(this.dbkRate);
      return (((fob * dbkRate) / 100) * exchangeRate).toFixed(2);
    },
    makeFieldsNull() {
      this.dbkUnder = null;
      this.isDbkItem = null;
      this.dialog = null;
      this.srNo = null;
      this.description = null;
      this.exciseDBKRate = null;
      this.customeDBKRate = null;
      this.unit = null;
      this.quantity = null;
      this.dbkScheduleNo = null;
      this.dbkQuantity = null;
      return;
    }
  },
  computed: {
    dbkScheduleDropdownValue: {
      get() {
        return this.$store.state.ExportModuleStore.drawback.dbkScheduleDropdownValue;
      },
      set(value) {
        // const schedule = { ...value };
        this.$store.commit(MT.SET_DRAWBACK_DBK_SCHEDULE_DROPDOWN_VALUE, { value: value.text });
        this.dbkRate = value.dbkRate;
        this.dbkScheduleNo = value.id;
        this.dbkAmount = this.reCalculateDbkAmount();
      }
    },
    dbkScheduleNo: {
      get() {
        return this.$store.state.ExportModuleStore.drawback.dbkScheduleNo;
      },
      set(value) {
        this.$store.commit(MT.SET_DRAWBACK_DBK_SCHEDULE_NO, { value });
      }
    },
    dbkQuantity: {
      get() {
        var quantity = this.$store.state.ExportModuleStore.drawback.dbkQuantity;
        if (quantity === null || quantity === undefined) {
          quantity = this.$store.state.ExportModuleStore.item.quantity;
        }
        return quantity;
      },
      set(value) {
        this.$store.commit(MT.SET_DRAWBACK_DBK_QUANTITY, { value });
      }
    },
    quantityUnit: {
      get() {
        return this.$store.state.ExportModuleStore.item.unitOfMeasurement;
      },
      set(value) {
        value;
      }
    },
    dbkRate: {
      get() {
        return this.$store.state.ExportModuleStore.drawback.dbkRate;
      },
      set(value) {
        this.$store.commit(MT.SET_DRAWBACK_DBK_RATE, { value });
      }
    },
    dbkAmount: {
      get() {
        const drawbackAmount = this.$store.state.ExportModuleStore.drawback.dbkAmount;
        if (drawbackAmount !== undefined && drawbackAmount !== null && !isNaN(drawbackAmount)) {
          return this.$store.state.ExportModuleStore.drawback.dbkAmount;
        }
        return this.reCalculateDbkAmount();
      },
      set(value) {
        this.$store.commit(MT.SET_DRAWBACK_DBK_AMOUNT, { value });
      }
    },
    units() {
      return this.$store.getters.units;
    },
    tableHeaders() {
      return [
        { text: "Sr No", value: "srNo" },
        { text: "Description", value: "description" },
        { text: "Excise DBK Rate", value: "exciseRate" },
        { text: "Customs DBK Rate", value: "customsRate" },
        { text: "Quantity", value: "quantity" },
        { text: "Unit", value: "unit" },
        { text: "Action", value: "action" }
      ];
    },
    declarations() {
      return this.$store.getters.declarations;
    },
    drawbackRates() {
      return this.$store.getters.drawbackRates;
    }
  }
};
</script>
<style lang="scss">
.drawback-tab {
  .boxed-form {
    border: solid 2px darkgrey;
    border-radius: 10px;
  }
  &__table {
    .v-data-table {
      background: transparent !important;
    }
  }
}
</style>
